import { Controller } from '@hotwired/stimulus';
import Cookies from 'js-cookie';

export default class extends Controller {
  static values = {
    encodedId: String,
  };

  declare encodedIdValue: string;

  dismiss(event: Event) {
    event.preventDefault();

    // Duplicate logic from useMessageVisibility.tsx
    const hiddenMessages = Cookies.get('hiddenMessages')?.split(',') || [];
    const updatedHiddenMessages = [...hiddenMessages, this.encodedIdValue];
    Cookies.set('hiddenMessages', updatedHiddenMessages.join(','));

    this.element.remove();
  }
}
